/* tslint:disable */


import { TagResource } from "app/models/TagResource";

export class NewsletterResource {
		email: string;
		errorCode: number;
		errorMessage: string;
		rid: number;
		tags: TagResource[];
		keepMyPersonalData: boolean;
		agreeToReceiveNewsletters: boolean;
		active: boolean;
		newEmail: string;
		keepFromDate: string;
		external: boolean;
		userEmail: string;

		showDetailsOnResponsive:boolean=false;
}
